import { Ban, Flame, Sword, Pill, Apple, Gem, Biohazard, Lightbulb } from "lucide-react";
import { Reveal } from "@/lib/motion";
import { PROHIBITED, SHIP_TIPS } from "@/lib/site-data";

const ICONS = {
  flammable: Flame, weapons: Sword, drugs: Pill,
  perishable: Apple, cash: Gem, hazard: Biohazard,
};

export default function Prohibited() {
  return (
    <section id="prohibited" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-[1320px] px-5 sm:px-8">
        <div className="grid gap-12 lg:grid-cols-[1.15fr_0.85fr]">
          <Reveal>
            <div>
              <div className="mb-4 flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.22em] text-[#E31B23]">
                <span className="h-px w-8 bg-[#E31B23]" /> Ship with confidence
              </div>
              <h2 className="max-w-xl font-display text-4xl font-extrabold leading-tight text-[#1F1F1F] sm:text-5xl">
                What we can't ship.
              </h2>
              <p className="mt-4 max-w-lg text-[#4b5563]">
                To keep every shipment safe and compliant, these items can't be carried. Unsure about
                something? Just ask — we'll clarify before you ship.
              </p>

              <div className="mt-10 grid gap-4 sm:grid-cols-2">
                {PROHIBITED.map((p) => {
                  const Icon = ICONS[p.key] || Ban;
                  return (
                    <div key={p.key} data-testid={`prohibited-${p.key}`}
                      className="flex items-start gap-4 rounded-2xl border border-black/5 bg-white p-5 shadow-[0_10px_30px_-22px_rgba(17,24,39,0.3)]">
                      <span className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl bg-[#E31B23]/10">
                        <Icon size={18} className="text-[#E31B23]" />
                      </span>
                      <div>
                        <div className="font-display text-base font-bold text-[#1F1F1F]">{p.title}</div>
                        <p className="mt-1 text-sm leading-relaxed text-[#4b5563]">{p.desc}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="lg:sticky lg:top-28 rounded-3xl p-8 text-white"
              style={{ background: "linear-gradient(150deg, #3D0A6E 0%, #5A189A 60%, #3D0A6E 100%)" }}>
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-white/15">
                <Lightbulb size={22} className="text-white" />
              </span>
              <h3 className="mt-6 font-display text-2xl font-bold">Packing tips</h3>
              <p className="mt-2 text-sm text-white/70">A few habits that keep your parcels moving smoothly.</p>
              <ul className="mt-6 space-y-4">
                {SHIP_TIPS.map((t, i) => (
                  <li key={i} className="flex items-start gap-3 text-sm text-white/90">
                    <span className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-[#E31B23] text-[11px] font-bold">{i + 1}</span>
                    {t}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
